export default "__VITE_ASSET__26221dac__"